import React from "react";
import { useDispatch } from "react-redux";
import { useRouter } from "next/router";
import { togglePaidInCollectionModal, togglePamentModal } from "store/modalReducer";
import { Icon } from "components/SvgIcons";
import Modal from "./Modal";
import CollectionList from "./CollectionsList";
import { Navigation, Back, BackTxt, Title, Hint } from "./styled";

const normalizeCollections = (collections) =>
  collections.map((c) => ({
    id: c.id,
    title: c.title,
    main_image: c.main_image,
    price: c.price,
  }));

const PaidInCollection = ({ recipe, collections = [], paidInCollectionsData = {} }) => {
  const dispatch = useDispatch();
  const router = useRouter();

  const { paidRecipe, collections: paidInCollections, recipeTitle } = paidInCollectionsData;
  const recipeCollections = recipe ? normalizeCollections(collections) : paidInCollections;

  const onClose = () => {
    dispatch(togglePaidInCollectionModal(false));
  };

  const onBack = () => {
    if (recipe) {
      onClose();
    } else {
      dispatch(togglePaidInCollectionModal(false));
      router.push(`/recipe/${paidRecipe}`);
    }
  };

  const openCollection = (id, buyCollection = false) => {
    dispatch(togglePaidInCollectionModal(false));
    if (router.asPath == `/collection/${id}`) {
      if (buyCollection) {
        dispatch(togglePamentModal(true));
      }
    } else {
      sessionStorage.setItem(
        "paidInCollections",
        JSON.stringify({
          collections: recipeCollections,
          paidRecipe: paidRecipe || recipe.id,
          recipeTitle: recipe?.title || recipeTitle,
          buyCollection,
        })
      );
      router.push(`/collection/${id}`);
    }
  };

  return (
    <Modal onClose={onClose}>
      <Navigation>
        <Back onClick={onBack}>
          <Icon icon="swipe_next" />
          <BackTxt>Back to recipe</BackTxt>
        </Back>
        <Icon icon="close_2" onClick={onClose} />
      </Navigation>
      <Title>{recipe?.title || recipeTitle}</Title>
      <Hint>This recipe is available in the following collections:</Hint>
      <CollectionList collections={recipeCollections} openCollection={openCollection} />
    </Modal>
  );
};

export default PaidInCollection;
